const Hamburger: React.FC<{
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
  isActive?: boolean;
}> = ({ onClick, isActive }) => (
  <button
    onClick={onClick}
    title="Toggle Nav"
    className={`relative block h-[21px] w-[28px] before:absolute before:left-0 before:top-0 before:h-[3px] before:w-[25px] before:origin-top-left before:rounded-[10px] before:bg-white before:shadow-[0_9px_0_#ffffff] before:content-[''] after:absolute after:bottom-0 after:left-0 after:h-[3px] after:w-[25px] after:origin-bottom-left after:rounded-[10px] after:bg-white after:content-[''] ${
      isActive
        ? `before:left-[6px] before:w-[26.5px] before:rotate-45 before:shadow-none after:left-[6px] after:w-[26.5px] after:-rotate-45`
        : ""
    } md:hidden`}
  />
);

export default Hamburger;
